<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title>
                  GST List
                  <v-spacer></v-spacer>
                  <v-flex xs12 sm4 md3 pt-10 pa-2>
                    <v-select
                      v-model="cat"
                      :items="categoryArray"
                      item-text="name"
                      item-value="_id"
                      item-color="#8d8d8d"
                      color="#8d8d8d"
                      outlined
                      dense
                      label="Category"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm4 md3 pt-10 pa-2>
                    <v-select
                      v-model="sub"
                      :items="subCategoryArray"
                      item-text="name"
                      item-value="_id"
                      item-color="#8d8d8d"
                      color="#8d8d8d"
                      outlined
                      dense
                      label="SubCategory"
                    >
                    </v-select>
                  </v-flex>
                  <v-btn
                    outlined
                    color="primary"
                    @click="(addDialog = true), (edit = false), (name = '')"
                  >
                    Add
                    <!-- <v-icon>mdi-plus</v-icon> -->
                  </v-btn>
                  <v-dialog v-model="addDialog" persistent max-width="600px">
                    <v-card>
                      <v-form v-model="formCategory" ref="formCategory">
                        <v-card-title>
                          <span v-if="edit == false" class="headline"
                            >Add GST</span
                          >
                          <span v-else class="headline">Edit GST</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12">
                                <v-select
                                  v-model="category"
                                  :items="categoryArray"
                                  item-text="name"
                                  item-value="_id"
                                  item-color="#8d8d8d"
                                  color="#8d8d8d"
                                  outlined
                                  dense
                                  label="Category"
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="12" sm="12">
                                <v-select
                                  v-model="subCategory"
                                  :items="subCategoryArray"
                                  item-text="name"
                                  item-value="_id"
                                  item-color="#8d8d8d"
                                  color="#8d8d8d"
                                  outlined
                                  dense
                                  label="SubCategory"
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="12">
                                <span style="font-weight: bold"
                                  >Price Range</span
                                >
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                  v-model="minPrice"
                                  outlined
                                  dense
                                  label="Minimum Price"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                  v-model="maxPrice"
                                  outlined
                                  dense
                                  label="Maximum Price"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                  v-model="taxPercentage"
                                  outlined
                                  dense
                                  label="Tax Percentage"
                                  required
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="red darken-1"
                            text
                            @click="addDialog = false"
                          >
                            Close
                          </v-btn>
                          <v-btn
                            v-if="edit == false"
                            color="blue darken-1"
                            text
                            :disabled="!formCategory"
                            @click="add()"
                          >
                            Save
                          </v-btn>
                          <v-btn
                            v-else
                            color="blue darken-1"
                            text
                            :disabled="!formCategory"
                            @click="Edit()"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </v-card-title>
              </v-card>
              <v-card class="mb-4">
                <v-card-text
                  style="
                    padding: 0px !important;
                    padding-top: 10px !important;
                    height: 4em !important;
                  "
                >
                  <v-layout wrap style="align-items: center" justify-center>
                    <v-flex xs6 sm6 md6></v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-layout wrap justify-center>
                        <v-flex xs6 sm6 md4 text-right pt-2
                          >Items Per Page</v-flex
                        >
                        <v-flex xs6 sm6 md2>
                          <v-select
                            solo
                            flat
                            v-model="itemsPerPage"
                            :items="ItemsCount"
                            dense
                            required
                          ></v-select>
                        </v-flex>
                        <!-- <v-flex
                          xs6
                          sm6
                          md2
                          text-center
                          pt-2
                          style="color: black"
                        >
                          {{ pageStart }}-{{ pageEnd }} of {{ count }}
                        </v-flex> -->
                        <v-flex xs2 sm2 md1 pt-2 text-right>
                          <span v-if="page > 1">
                            <v-icon @click="prevpage" color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-center>
                          <!-- <v-text-field
                              v-model="page"
                              color="#26af82"
                              min="1"
                              :dense="true"
                              :max="totalpages"
                              type="number"
                              class="centered-input"
                            ></v-text-field> -->
                          {{ page }}
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-left>
                          <span v-if="page < totalpages">
                            <v-icon @click="nextpage" color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-data-table
                  bordered
                  :headers="headers"
                  :items="list"
                  hide-default-footer
                  :items-per-page="itemsPerPage"
                  class="row-pointer pb-12 tableValue"
                >
                  <template v-slot:[`item.subcategoryId`]="{ item }">
                    <span>{{ item.subcategoryId.name }}</span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      color="primary"
                      @click.stop="editCategoryDialog(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-dialog v-model="item.deleteCategory" max-width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          color="red"
                          @click="deleteConfirmation(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <v-card>
                        <v-card-title class="headline grey lighten-2">
                          Delete Confirmation
                        </v-card-title>
                        <v-card-text>
                          <span style="font-size: 16px; font-weight: 600"
                            >Please confirm that you want to Remove this GST?
                          </span>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn
                            color="primary"
                            @click="item.deleteCategory = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="error"
                            class="mr-4"
                            @click="DeleteCategory(item)"
                          >
                            Delete
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      headers: [
        { text: "Subcategory", value: "subcategoryId", sortable: false },
        { text: "Min Price", value: "minPrice" },
        { text: "Max Price", value: "maxPrice" },
        { text: "Tax Percentage", value: "taxPercentage" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      edit: false,
      cat: "",
      sub: "",
      editId: "",
      dialog: false,
      addDialog: false,
      editdialog: false,
      deleteCategory: false,
      formCategory: false,
      cId: null,
      list: [],
      category: "",
      categoryArray: [],
      categoryImg: null,
      attachments: null,
      minPrice: null,
      maxPrice: null,
      taxPercentage: null,
      subCategory: "",
      subCategoryArray: [],
      editingitem: [],
      name: "",
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      itemsPerPage: 20,
      page: 1,
      totalpages: 0,
      ItemsCount: [20, 30, 50, 100],
      msg: "",
      showsnackbar: false,
      timeout: 3000,
    };
  },
  beforeMount() {
    this.getList();
    this.getCategory();
  },
  watch: {
    itemsPerPage: function () {
      this.getList();
    },
    category() {
      this.getSubCategory();
    },
    cat() {
      this.getList();
      this.getSub();
    },
    sub() {
      this.getList();
    },
  },
  methods: {
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getList();
        // } else {
        //   this.page--;
        //   this.getcategory();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getList();
        // } else {
        //   this.page++;
        //   this.getcategory();
        // }
      }
    },
    getList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/tax/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          limit: this.itemsPerPage,
          page: this.page,
          categoryId: this.cat,
          subcategoryId: this.sub,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.list = response.data.data;
          this.count = response.data.totalLength;
          this.totalpages = Math.ceil(
            response.data.totalLength / this.itemsPerPage
          );
          if (response.data.length > 0) {
            this.pageStart = (response.data.page - 1) * response.data.limit + 1;
            this.pageEnd = this.pageStart + response.data.length - 1;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/category/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.categoryArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getSubCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/subcategory/list/" + this.category,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subCategoryArray = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    getSub() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/subcategory/list/" + this.cat,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subCategoryArray = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    add() {
      this.addDialog = false;
      var data = {};
      data["subcategoryId"] = this.subCategory;
      data["minPrice"] = this.minPrice;
      data["maxPrice"] = this.maxPrice;
      data["taxPercentage"] = this.taxPercentage;
      data["categoryId"] = this.category;
      axios({
        url: "/tax/add",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "GST Added!";
            this.showsnackbar = true;
            this.getList();
            this.name = null;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteConfirmation() {
      this.deleteCategory = true;
    },
    DeleteCategory(item) {
      item.deleteCategory = false;
      axios({
        url: "/tax/delete/" + item._id,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "GST Deleted";
            this.showsnackbar = true;
            this.getList();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editCategoryDialog(item) {
      this.edit = true;
      this.addDialog = true;
      this.subCategory = item.subcategoryId;
      this.category = item.categoryId;
      this.minPrice = item.minPrice;
      this.maxPrice = item.maxPrice;
      this.taxPercentage = item.taxPercentage;
      this.editId = item._id;
    },
    Edit() {
      this.addDialog = false;
      var data = {};
      data["subcategoryId"] = this.subCategory;
      data["id"] = this.editId;
      data["categoryId"] = this.category;
      data["minPrice"] = this.minPrice;
      data["maxPrice"] = this.maxPrice;
      data["taxPercentage"] = this.taxPercentage;
      axios({
        url: "/tax/edit",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;
          this.edit = false;
          this.appLoading = false;

          if (response.data.status) {
            this.getList();
            this.msg = "GST Edited";
            this.showsnackbar = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    // rowClicked(item) {
    //   this.$router.push("/category/" + item._id);
    // },
  },
};
</script>
<style >
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>



